import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './PreparingStoryProcessing.module.scss';
import { PROJECT_STATE } from '../../constants/projectCreatorConsts';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../Button/Button';
import StoryboardSpinner from '../../features/Storyboard/components/StoryboardSpinner/StoryboardSpinner';

const PreparingStoryProcessing = ({ state, hideText = false }) => {
  const [text, setText] = useState('storyboard.preparing.narrative');
  const [headerOpacity, setOpacity] = useState(1);

  const { t } = useTranslation();

  useEffect(() => {
    if (state === PROJECT_STATE.GENERATING_SCRIPT) {
      setOpacity(0);
      setTimeout(() => {
        setOpacity(1);
        setText('storyboard.preparing.script');
      }, [250]);
    }
  }, [state]);

  const history = useHistory();
  return (
    <div className={styles.wrapper}>
      <div className={styles.loaderProcessing}>
        <StoryboardSpinner text={!hideText && t(text)} textStyle={{ opacity: headerOpacity }} />
        <CustomButton
          variant="secondary"
          onClick={() => history.goBack()}
          label={t('storyboard.preparing.narrative.back')}
          className={styles.controlBtn}
        />
      </div>
    </div>
  );
};

export default PreparingStoryProcessing;
